const FRONTEND_ROLE_TO_BACKEND_SLUG = {
  manager: "manager",
  "department-manager": "department_manager",
  hr: "hr",
  "hr-staff": "hr_staff",
  gm: "gm",
};

function isDirectManagerFamilySlug(slug) {
  return (
    slug === "manager" || slug === "team_leader" || slug === "supervisor"
  );
}

function matchesApproverSlug(userSlugs, requiredSlug) {
  if (!requiredSlug) return false;
  if (userSlugs.includes(requiredSlug)) return true;
  if (
    requiredSlug === "hr" &&
    (userSlugs.includes("hr") || userSlugs.includes("hr_staff"))
  ) {
    return true;
  }
  if (
    isDirectManagerFamilySlug(requiredSlug) &&
    userSlugs.some((slug) => isDirectManagerFamilySlug(slug))
  ) {
    return true;
  }
  return false;
}

export function resolveUserSlugs(user) {
  if (user?.backendRoles?.length) return user.backendRoles;
  const mapped = FRONTEND_ROLE_TO_BACKEND_SLUG[user?.role];
  return mapped ? [mapped] : [];
}

export function canUserApproveWfh(row, user) {
  if (!row || String(row.status || "").toUpperCase() !== "PENDING") {
    return false;
  }
  const workflowStatus = row.workflowStatus || row.request?.status;
  if (
    workflowStatus &&
    !["PENDING", "IN_PROGRESS"].includes(String(workflowStatus).toUpperCase())
  ) {
    return false;
  }

  const currentStep = row.currentStep ?? row.request?.currentStep;
  const steps = row.workflow?.steps || [];
  const activeStep = steps.find((step) => step.stepOrder === currentStep);
  const requiredSlug =
    activeStep?.approverRole?.slug || row.nextApprover?.roleSlug;
  if (!requiredSlug) return false;

  return matchesApproverSlug(resolveUserSlugs(user), requiredSlug);
}

function isOwnWfhRequest(row, user) {
  if (!row || !user) return false;
  if (user.employeeId && row.employeeId === user.employeeId) return true;
  if (user.employeeId && row.employee?.id === user.employeeId) return true;
  return false;
}

/** طلبات WFH المعلقة التي المستخدم الحالي هو المعتمد التالي لها. */
export function countPendingWfhApprovals(wfhRequests = [], user) {
  if (!user) return 0;
  return (wfhRequests || []).filter(
    (row) => !isOwnWfhRequest(row, user) && canUserApproveWfh(row, user),
  ).length;
}
